import { render, staticRenderFns } from "./StandardOrderStatisticsTable.vue?vue&type=template&id=088dae9a&scoped=true&"
import script from "./StandardOrderStatisticsTable.vue?vue&type=script&lang=js&"
export * from "./StandardOrderStatisticsTable.vue?vue&type=script&lang=js&"
import style0 from "./StandardOrderStatisticsTable.vue?vue&type=style&index=0&id=088dae9a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "088dae9a",
  null
  
)

export default component.exports